import _DatabaseModel from "./_DatabaseModel";

class Vulnerability extends _DatabaseModel {
  static model = "vulnerability";
  static showSize = 8;
  static editDialogComponent = "vulnerabilities-edit-dialog";
  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];

  static show = {
    buttons: ["edit"],
    reloadingModels: ["control"],
  };

  static filter = {
    parts: {
      fields: ["name", "description", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static operations = ["export"];
  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [this.detailTab];
}

export default Vulnerability;
